import React from 'react'
import T from 'prop-types'
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined'
import { useTranslation } from 'react-i18next'

import Tooltip from './Tooltip'
import IconButton from './IconButton'

// REL-F05 · Toolbar button that downloads the REL-18 Release "situazione" report.
// Mirrors ClipboardWithTrendUp / DownloadBar (Tooltip + outlined IconButton).
export default function ReleaseReportBar({
  handleDownload = () => {},
  disabled = false,
}) {
  const { t } = useTranslation()
  return (
    <Tooltip title={t('partnerInventory.downloadReleaseReport')}>
      <div>
        <IconButton
          data-testid="download-release-report-button"
          onClick={handleDownload}
          variant="outlined"
          disabled={disabled}
        >
          <SummarizeOutlinedIcon />
        </IconButton>
      </div>
    </Tooltip>
  )
}

ReleaseReportBar.propTypes = {
  handleDownload: T.func,
  disabled: T.bool,
}
